import { InjectionToken } from '@angular/core';
import * as Rx from 'rxjs';

export const LOCAL_STORAGE_TEST_SCHEDULER = new InjectionToken<Rx.SchedulerLike>(
  'LocalStorageTestScheduler',
);
